/**
 * Cross-sells carousel — static HTML cards; catalog only updates images + prices.
 */
(function () {
  "use strict";

  var SUBSCRIBE_DISCOUNT = 0.15;
  var catalogUrl = new URL("data/catalog.json", document.baseURI).href;
  var refreshArrows = null;

  function mediaUrl(relativePath) {
    if (!relativePath) return "";
    return new URL(
      "../../content/" + relativePath.replace(/^\//, ""),
      document.baseURI
    ).href;
  }

  function parsePrice(str) {
    if (!str) return null;
    var n = parseFloat(String(str).replace(/[^0-9.]/g, ""));
    return isNaN(n) ? null : n;
  }

  function fmtPrice(n) {
    return "$" + n.toFixed(2);
  }

  function subscribePrice(product) {
    var base = parsePrice(product.price);
    return base ? fmtPrice(base * (1 - SUBSCRIBE_DISCOUNT)) : product.price || "";
  }

  function setMedia(slide, product) {
    var mediaWrap = slide.querySelector(".cross-sell-product__media .media");
    if (!mediaWrap) return;

    var imgPath =
      product.media && product.media.frontBottle
        ? mediaUrl(product.media.frontBottle)
        : "";
    var name = product.displayName || product.handle;

    if (imgPath) {
      mediaWrap.innerHTML =
        '<img src="' +
        imgPath +
        '" alt="' +
        name.replace(/"/g, "&quot;") +
        '" loading="lazy" />';
    }
  }

  function hydrateFromCatalog(catalog) {
    var root = document.querySelector("[data-cross-sells-root]");
    if (!root) return;

    var byHandle = {};
    catalog.products.forEach(function (p) {
      byHandle[p.handle] = p;
    });

    root.querySelectorAll(".cross-sells__slide[data-handle]").forEach(function (slide) {
      var product = byHandle[slide.getAttribute("data-handle")];
      if (!product) return;

      // Price is set from live Shopify data in hydrateRealPrices() so the
      // number always matches what the one-time "Add" button charges.

      var addBtn = slide.querySelector(".cross-sell-product__add");
      if (addBtn) {
        addBtn.setAttribute(
          "aria-label",
          "Add " + (product.displayName || product.handle) + " to cart"
        );
      }

      setMedia(slide, product);
    });

    if (refreshArrows) refreshArrows();
  }

  function initCarousel(root) {
    if (root.dataset.carouselWired === "true") {
      if (refreshArrows) refreshArrows();
      return;
    }
    root.dataset.carouselWired = "true";

    var track = root.querySelector("[data-cross-sells-track]");
    var prev = root.querySelector("[data-prev-button]");
    var next = root.querySelector("[data-next-button]");
    if (!track || !prev || !next) return;

    function slides() {
      return track.querySelectorAll(".cross-sells__slide");
    }

    function activeIndex() {
      var scrollLeft = track.scrollLeft;
      var best = 0;
      var bestDist = Infinity;
      slides().forEach(function (slide, i) {
        var dist = Math.abs(slide.offsetLeft - scrollLeft);
        if (dist < bestDist) {
          bestDist = dist;
          best = i;
        }
      });
      return best;
    }

    function updateArrows() {
      var list = slides();
      if (list.length <= 1) {
        prev.disabled = true;
        next.disabled = true;
        return;
      }
      var maxScroll = track.scrollWidth - track.clientWidth;
      prev.disabled = track.scrollLeft <= 1;
      next.disabled = track.scrollLeft >= maxScroll - 1;
      prev.classList.toggle("swiper-button-disabled", prev.disabled);
      next.classList.toggle("swiper-button-disabled", next.disabled);
    }

    refreshArrows = updateArrows;

    function scrollToIndex(idx) {
      var list = slides();
      var slide = list[idx];
      if (!slide) return;
      track.scrollTo({ left: slide.offsetLeft, behavior: "smooth" });
    }

    prev.addEventListener("click", function () {
      scrollToIndex(Math.max(0, activeIndex() - 1));
    });
    next.addEventListener("click", function () {
      scrollToIndex(Math.min(slides().length - 1, activeIndex() + 1));
    });
    track.addEventListener("scroll", function () {
      window.requestAnimationFrame(updateArrows);
    });

    var dragging = false;
    var startX = 0;
    var scrollStart = 0;

    track.addEventListener("mousedown", function (e) {
      if (e.button !== 0) return;
      dragging = true;
      startX = e.pageX;
      scrollStart = track.scrollLeft;
      track.classList.add("is-dragging");
    });
    window.addEventListener("mouseup", function () {
      if (!dragging) return;
      dragging = false;
      track.classList.remove("is-dragging");
      updateArrows();
    });
    track.addEventListener("mousemove", function (e) {
      if (!dragging) return;
      e.preventDefault();
      track.scrollLeft = scrollStart - (e.pageX - startX);
    });
    track.addEventListener(
      "wheel",
      function (e) {
        if (Math.abs(e.deltaY) <= Math.abs(e.deltaX)) return;
        track.scrollLeft += e.deltaY;
        e.preventDefault();
        updateArrows();
      },
      { passive: false }
    );

    updateArrows();
  }

  function rootPath(path) {
    var root =
      (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || "/";
    return root.replace(/\/$/, "") + path;
  }

  function productUrl(handle) {
    if (!handle) return "#";
    if (window.Shopify && window.Shopify.routes && window.Shopify.routes.root !== undefined) {
      var shopRoot = window.Shopify.routes.root || "/";
      return shopRoot + "products/" + encodeURIComponent(handle);
    }
    if (window.FB_PREVIEW_LOCAL) {
      var previewUrl = "/live/products/" + encodeURIComponent(handle);
      if (window.FB_PREVIEW_THEME_ID) {
        previewUrl += "?preview_theme_id=" + encodeURIComponent(window.FB_PREVIEW_THEME_ID);
      }
      return previewUrl;
    }
    return rootPath("/products/" + handle);
  }

  // Add a cross-sell product straight to the cart as a single-bottle,
  // one-time purchase (quantity 1, no subscription plan attached).
  function addCrossSellToCart(handle, btn) {
    if (!handle || btn.dataset.adding === "true") return;
    btn.dataset.adding = "true";
    var label = btn.querySelector(".button-text-short");
    var original = label ? label.textContent : "";
    if (label) label.textContent = "Adding…";

    fetch(rootPath("/products/" + handle + ".js"), {
      headers: { Accept: "application/json" },
    })
      .then(function (res) {
        if (!res.ok) throw new Error("Could not load product " + handle);
        return res.json();
      })
      .then(function (product) {
        var variant = null;
        var variants = product.variants || [];
        for (var i = 0; i < variants.length; i++) {
          if (variants[i].available) {
            variant = variants[i];
            break;
          }
        }
        if (!variant && variants.length) variant = variants[0];
        if (!variant) throw new Error("No variant for " + handle);

        return fetch(rootPath("/cart/add.js"), {
          method: "POST",
          headers: { "Content-Type": "application/json", Accept: "application/json" },
          body: JSON.stringify({ id: variant.id, quantity: 1 }),
        });
      })
      .then(function (res) {
        if (!res.ok) throw new Error("Could not add to cart");
        return res.json();
      })
      .then(function () {
        document.dispatchEvent(new CustomEvent("v4:cart-updated"));
        if (window.V4ShopifyCart && window.V4ShopifyCart.openDrawer) {
          window.V4ShopifyCart.openDrawer();
        }
        if (label) label.textContent = "Added ✓";
        window.setTimeout(function () {
          if (label) label.textContent = original;
          btn.dataset.adding = "false";
        }, 1400);
      })
      .catch(function (err) {
        console.error(err);
        if (label) label.textContent = "Try again";
        window.setTimeout(function () {
          if (label) label.textContent = original;
          btn.dataset.adding = "false";
        }, 1400);
      });
  }

  // Show the real one-time single-bottle price on each card, pulled live from
  // Shopify, so the displayed price always matches what the "Add" button charges.
  function hydrateRealPrices(root) {
    root
      .querySelectorAll(".cross-sells__slide[data-handle]")
      .forEach(function (slide) {
        var handle = slide.getAttribute("data-handle");
        var priceEl = slide.querySelector(".cross-sell-product__price");
        if (!handle || !priceEl) return;

        fetch(rootPath("/products/" + handle + ".js"), {
          headers: { Accept: "application/json" },
        })
          .then(function (res) {
            if (!res.ok) throw new Error("price fetch failed");
            return res.json();
          })
          .then(function (product) {
            var variants = product.variants || [];
            var variant = null;
            for (var i = 0; i < variants.length; i++) {
              if (variants[i].available) {
                variant = variants[i];
                break;
              }
            }
            if (!variant && variants.length) variant = variants[0];
            if (!variant) return;
            priceEl.textContent = fmtPrice(variant.price / 100);
            priceEl.removeAttribute("data-price-subscribe");
          })
          .catch(function () {
            /* Leave existing price text if the lookup fails */
          });
      });
  }

  function wireAddButtons(root) {
    if (root.dataset.addWired === "true") return;
    root.dataset.addWired = "true";
    root.addEventListener("click", function (e) {
      var btn = e.target.closest(".cross-sell-product__add");
      if (!btn) return;
      e.preventDefault();
      e.stopPropagation();
      var slide = btn.closest("[data-handle]");
      var handle = slide ? slide.getAttribute("data-handle") : null;
      addCrossSellToCart(handle, btn);
    });
  }

  // Ensure every card links to its PDP (name, image, and copy area).
  function wireProductLinks(root) {
    if (root.dataset.linksWired === "true") return;
    root.dataset.linksWired = "true";

    root.querySelectorAll(".cross-sells__slide[data-handle]").forEach(function (slide) {
      var handle = slide.getAttribute("data-handle");
      var url = productUrl(handle);
      if (!handle || !url || url === "#") return;

      slide.querySelectorAll(
        ".cross-sell-product__copy-link, .cross-sell-product__media-link, .cross-sell-product__name-link"
      ).forEach(function (link) {
        link.setAttribute("href", url);
      });

      var nameEl = slide.querySelector(".cross-sell-product__name");
      if (nameEl && !nameEl.closest("a")) {
        var nameLink = document.createElement("a");
        nameLink.href = url;
        nameLink.className = "cross-sell-product__name-link";
        nameEl.parentNode.insertBefore(nameLink, nameEl);
        nameLink.appendChild(nameEl);
      }

      var mediaInner = slide.querySelector(".cross-sell-product__media .media");
      if (mediaInner && !mediaInner.closest("a.cross-sell-product__media-link")) {
        var mediaLink = document.createElement("a");
        mediaLink.href = url;
        mediaLink.className = "cross-sell-product__media-link";
        mediaLink.setAttribute("tabindex", "-1");
        mediaLink.setAttribute("aria-hidden", "true");
        mediaInner.parentNode.insertBefore(mediaLink, mediaInner);
        mediaLink.appendChild(mediaInner);
      }
    });
  }

  function boot() {
    var root = document.querySelector("[data-cross-sells-root]");
    if (!root) return;
    initCarousel(root);
    wireAddButtons(root);
    wireProductLinks(root);
    hydrateRealPrices(root);

    fetch(catalogUrl)
      .then(function (res) {
        if (!res.ok) throw new Error(res.status);
        return res.json();
      })
      .then(hydrateFromCatalog)
      .catch(function () {
        /* Static cards + prices remain */
      });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", boot);
  } else {
    boot();
  }
})();
